// src/components/DetailsCalendarModal.js
import React from "react";
import "./DetailsCalendarModal.css";

/**
 * props:
 *  visible        – bool
 *  date           – Date()
 *  birthdays      – [{ name, age }]
 *  anniversaries  – [tekst]
 *  workEntries    – [{
 *      first_name, last_name,
 *      nr_ref, tytul, hours, start_time, end_time
 *    }]
 *  onClose()      – funkcja zamknięcia
 */
export default function DetailsCalendarModal({
  visible,
  date,
  birthdays = [],
  anniversaries = [],
  workEntries = [],
  onClose,
}) {
  if (!visible) return null;

  const formatter = new Intl.DateTimeFormat("pl-PL", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });
  const header = formatter.format(date);

  return (
    <div className="modal-overlay" onClick={onClose}>
      {/* zatrzymujemy propagację click, by klik w środku NIE zamykał */}
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>×</button>

        <h2 className="modal-title">Szczegóły dnia {header}</h2>

        {/* ------- URODZINY ------- */}
        {birthdays.length > 0 && (
          <>
            <h3>Urodziny</h3>
            <ul className="modal-list">
              {birthdays.map((b, i) => (
                <li key={i}>
                  {b.name} – {b.age} lat(a)
                </li>
              ))}
            </ul>
          </>
        )}

        {/* ------- ROCZNICE ------- */}
        {anniversaries.length > 0 && (
          <>
            <h3>Rocznice</h3>
            <ul className="modal-list">
              {anniversaries.map((txt, i) => (
                <li key={i}>{txt}</li>
              ))}
            </ul>
          </>
        )}

		{/* ------- CZAS PRACY ------- */}
		{workEntries.length > 0 && (
		  <>
			<h3>Czas pracy</h3>

			<table className="work-table">
			  <thead>
				<tr>
				  <th>Pracownik</th>
				  <th>Zlecenie</th>
				  <th>Tytuł</th>
				  <th>Czas</th>
				  <th>Od</th>
				  <th>Do</th>
				</tr>
			  </thead>
			  <tbody>
				{workEntries.map((w, i) => (
				  <tr key={i}>
					<td>{w.first_name} {w.last_name}</td>
					<td><strong>{w.nr_ref}</strong></td>
					<td>{w.tytul}</td>
					<td>{w.hours}</td>
					{/* skracamy „07:00:00” → „07:00” */}
					<td>{w.start_time.slice(0,5)}</td>
					<td>{w.end_time.slice(0,5)}</td>
				  </tr>
				))}
			  </tbody>
			</table>
		  </>
		)}

        {/* brak danych */}
        {birthdays.length === 0 &&
          anniversaries.length === 0 &&
          workEntries.length === 0 && (
            <p className="modal-empty">Brak zdarzeń dla wybranych filtrów.</p>
          )}
      </div>
    </div>
  );
}
